<app-modal-box [maxWidth]="800" [gapValue]="'0px'">
  <div class="content">
    <div class="top">
      <p class="title">My Support Tickets</p>
    </div>
    <div class="table">
      @if (supportService.tickets.length > 0) {
      <div class="table-head">
        <div class="head small">ID</div>
        <div class="head large">Title</div>
        <div class="head medium">Last Response</div>
        <div class="head small">Status</div>
        <div class="head small">Action</div>
      </div>
      } @for (ticket of supportService.tickets; track ticket.id; let e = $even) {
      <div class="table-row" [class.colored-bg]="e">
        <div class="item small ticket-id" data-label="ID">{{ ticket.id }}</div>
        <div class="item large" data-label="Title">{{ ticket.title }}</div>
        <div class="item medium" data-label="Last Update">{{ (ticket.responded | date : 'dd.MM.yy, hh:mm:ss') ?? 'No Response' }}</div>
        <div
          class="item small"
          data-label="Status"
          [class.c-green]="ticket.status === 'Closed'"
          [class.c-secondary]="ticket.status === 'Opened' || ticket.status === 'User Responded'"
          [class.c-yellow]="
            (!session.is_admin && ticket.status === 'Staff Responded') || (session.is_admin && ticket.status === 'User Responded') || ticket.status === 'Staff Responded'
          "
        >
          @if (ticket.status === 'Closed') {
          <!--  -->
          Closed
          <!--  -->
          } @else if (ticket.status === 'Staff Responded') {
          <!--  -->
          Staff responded
          <!--  -->
          } @else if (ticket.status === 'User Responded') {
          <!--  -->
          Waiting for staff
          <!--  -->
          } @else { Opened }
        </div>
        <div class="item actions extra-small">
          <button class="button transparent" (click)="viewTicket(ticket)">View</button>
        </div>
      </div>
      }
    </div>
    <p class="sub-text">
      Please make sure to read our FAQ page with different categories before contacting support, you can read it here:
      <span class="faq-link" routerLink="/faq" (click)="closeModal()">View FAQ</span>
    </p>
    <button class="button red medium-2" (click)="openCreateTicket()">Create Ticket</button>
  </div>
</app-modal-box>
